import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OrganizationResponse } from '../types/Organization';

interface ReorderOrganizationMembersParams {
  userOrders: Array<{ id: number; order_number: number }>;
}

/**
 * 組織メンバーの順序変更用のフック
 */
export default function useReorderOrganizationMembers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userOrders }: ReorderOrganizationMembersParams) => {
      const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
      const response = await fetch('/agent/api/organization_users/reorder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          user_orders: userOrders,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '順序の更新に失敗しました');
      }

      const data: OrganizationResponse = await response.json();
      return data;
    },
    onSuccess: (data) => {
      // サーバーから返された正しい順序でキャッシュを更新
      queryClient.setQueryData<OrganizationResponse>(['organization'], data);
    },
  });
}
